import { IPublishPage, IPageIfm } from '@/services/interface'
import { useEffect, useRef, useState } from 'react'
import { getDraftList, createDraft } from '@/services/apis/aiwriter'
import { history } from '@umijs/max'


const usePageModel = () => {
  const [curPageIfm, setCurPageIfm] = useState<IPublishPage>({} as IPublishPage)
  const [searchValue, setSearchValue] = useState<string>('')
  const [draftStatus, setDraftStatus] = useState<string | undefined>(undefined) // 草稿状态筛选
  const [pageList, setPageList] = useState<Array<IPageIfm>>([])  // 文章列表
  const [hasArticleAuth, setHasArticleAuth] = useState<boolean>(true) // 是否有文章权限
  const [articleIdInexistence, setArticleIdInexistence] = useState<boolean>(false) // 文章id不存在
  const curPageIfmRef = useRef<IPublishPage>(curPageIfm)
  
  const updatePageInfo = (pageIfm: Partial<IPublishPage>) => {
    // 先更新ref，再更新state，保证state是最新的
    curPageIfmRef.current = {
      ...curPageIfmRef.current,
      ...pageIfm
    }
    setCurPageIfm({
      ...curPageIfmRef.current,
      ...pageIfm,
    })
  }

  useEffect(() => {
    curPageIfmRef.current = curPageIfm
  }, [curPageIfm])

  // 获取所有文章
  const getAllPages = async () => {
    const data = await getDraftList()
    const { drafts = [] } = data ?? {}
    setPageList(drafts)
  }

  // 初始化页面获取文章列表
  const initGetPages = async () => {
    // 先获取列表，如果存在，跳转第一个，如果没有，生成一个新的
    const data = await getDraftList()
    const { drafts = [] } = data ?? {}
    setPageList(drafts)
    if (drafts.length > 0) {
      history.push(`/writer/${drafts[0].id}`)
      return
    }

    // 文章列表为空
    initDraftList()
  }

  // 初始化生成一个文章,并跳转到编辑页面
  const initDraftList = async () => {
    const pageId = await createDraft()
    history.push(`/writer/${pageId}`)
    getAllPages()
  }

  return {
    curPageIfm,
    pageList,
    hasArticleAuth,
    articleIdInexistence,
    setHasArticleAuth,
    setArticleIdInexistence,
    setPageList,
    getAllPages,
    setCurPageIfm,
    updatePageInfo,
    initGetPages,
    initDraftList,
    searchValue,
    setSearchValue,
    draftStatus,
    setDraftStatus
  }
}

export default usePageModel
